import * as RestClient from '../../utils/rest-service';
import Constants from '../../config/constants';

export const ACTION = {
  LIST: 'LIST_FLOOR',
  GET: 'GET_FLOOR',
  CREATE: 'CREATE_FLOOR',
  EDIT: 'EDIT_FLOOR',
  DELETE: 'DELETE_FLOOR',
  DUPLICATE: 'DUPLICATE_FLOOR',
  ADD_FLOOR_TO_PROJECT: 'ADD_FLOOR_TO_PROJECT',
  REMOVE_FLOOR_FROM_PROJECT: 'REMOVE_FLOOR_FROM_PROJECT',
  CLEAR_ERROR: 'CLEAR_ERROR_FLOOR',
};

export const searchFloorByText = (text, buildingId, page = 0) => {
  const pageSize = Constants.DATA_TABLE_PAGE_SIZE;
  const sorted = null;
  const filtered = text;
  const isPublic = null;
  return searchFloor(pageSize, page, sorted, filtered, isPublic, buildingId);
};

export const searchFloor = (pageSize, page, sorted, filtered, isPublic, buildingId) => {
  return RestClient.request({
    method: 'get',
    url: Constants.API_FLOOR,
    params: {
      search: filtered,
      limit: pageSize,
      offset: pageSize * page,
      ordering: sorted
        ? sorted.map(sort => sort.desc ? `-${sort.id}` : sort.id ).join(',')
        : null,
      is_public: isPublic,
      building_id: buildingId,
    },
  });
};

export const listFloor = (pageSize, page, sorted, filtered, isPublic, buildingId) => {
  return {
    type: ACTION.LIST,
    payload: searchFloor(pageSize, page, sorted, filtered, isPublic, buildingId)
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const getFloor = floorId => {
  return {
    type: ACTION.GET,
    payload: RestClient.request({
      method: 'get',
      url: `${Constants.API_FLOOR}${floorId}/`,
    }).catch(err => Promise.reject(err.response.data.detail)),
  };
};

export const createFloor = (name, buildingId, description) => {
  const formData = new FormData();
  formData.set('name', name);
  formData.set('building_id', buildingId === null ? '' : buildingId);
  formData.set('description', description);

  return {
    type: ACTION.CREATE,
    payload: RestClient.request({
      method: 'post',
      url: Constants.API_FLOOR,
      data: formData,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const editFloor = (id, name, buildingId, description) => {
  const formData = new FormData();
  if (name) formData.set('name', name);
  formData.set('building_id', buildingId === null ? '' : buildingId);
  if (typeof description === 'string') formData.set('description', description);

  return {
    type: ACTION.EDIT,
    payload: RestClient.request({
      method: 'patch',
      url: `${Constants.API_FLOOR}${id}/`,
      data: formData,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const deleteFloor = (floorId, params) => {
  return {
    type: ACTION.DELETE,
    payload: RestClient.request({
      method: 'delete',
      url: `${Constants.API_FLOOR}${floorId}/`,
      data: params,
    })
      .then(() => ({ id: floorId }))
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const duplicateFloor = (id, name) => {
  const data = { new_name: name };
  return {
    type: ACTION.DUPLICATE,
    payload: RestClient.request({
      method: 'post',
      url: `${Constants.API_FLOOR}${id}/copy/`,
      data,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const addFloorToProject = (id, projectId) => {
  const formData = new FormData();
  formData.set('project_id', projectId);

  return {
    type: ACTION.ADD_FLOOR_TO_PROJECT,
    payload: RestClient.request({
      method: 'patch',
      url: `${Constants.API_FLOOR}${id}/`,
      data: formData,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const removeFloorFromProject = id => {
  const formData = new FormData();
  formData.set('project_id', '');

  return {
    type: ACTION.REMOVE_FLOOR_FROM_PROJECT,
    payload: RestClient.request({
      method: 'patch',
      url: `${Constants.API_FLOOR}${id}/`,
      data: formData,
    })
      .then(() => ({ id }))
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const clearErrorFloor = () => {
  return {
    type: ACTION.CLEAR_ERROR,
  };
};



// WEBPACK FOOTER //
// ./src/redux/floor/floor_actions.js